import { useMediaQuery } from "react-responsive";

const useMediaScreen = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = useMediaQuery({ minWidth: 1024, maxWidth: 1279 });
  const isLargeDesktop = useMediaQuery({ minWidth: 1280 });

  return { isMobile, isTablet, isDesktop, isLargeDesktop };
};

export default useMediaScreen;
